module.exports = __webpack_public_path__ + "static/media/mediumLeaf.c65209fe.png";